










import { Component, Vue, Prop, Watch } from 'vue-property-decorator'

@Component
export default class Selector extends Vue {

  @Prop({ type: String, default: 'radio' }) type: string
  @Prop({ type: String, default: null }) position: string
  @Prop({ type: Array, default: () => [] }) items: any[]
  @Prop({ type: String, default: null }) current
  @Prop({ type: Boolean, default: false }) full: boolean

  get placeholder() {
    return this.current ? this.current : this.$t('global.dropdown.placeholder')
  }

  get placeholderClass() {
    return this.current ? 'has-text-dark' : 'has-text-gray'
  }

  @Watch('current')
  updateCurrent(current) {
    this.$nextTick(() => {
      if (current) {
        const item = this.items.find((i) => current === i.label)
        console.log(item)
        this.$emit('change', item)
      }
    })
  }

  change(item) {
    this.$emit('change', item)
  }
}
